import Login from "@/components/Login.vue";
import ForgotPassword from "@/components/ForgotPassword.vue";

export default {
    '/': Login,
    '/forgot-password/': ForgotPassword,
}